/* istanbul ignore file */
import { useMutation } from '@tanstack/react-query';
import { api } from 'src/app/api/base';

interface UpdatePayload {
  toUpdate: Array<string>;
}

export function useUpdateAppleApplicationInfo(deviceId: string) {
  return useMutation({
    mutationKey: ['update-device-info', deviceId],
    mutationFn: async (payload: UpdatePayload) => {
      const { toUpdate } = payload;

      const response = await api(`/mdm/${deviceId}/update-info/`).post({
        to_update: toUpdate,
      });

      return response.data;
    },
  });
}
